"use client";

import { useContext } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { FilterParamsContext } from "../FilterParamsProvider";
import { State } from "@/postgres";

export default function StateSelectClient({
  stateMap,
}: {
  stateMap: Map<string, State>;
}) {
  const { filterParams, setFilterParams } = useContext(FilterParamsContext);

  return (
    <Autocomplete
      multiple
      options={Array.from(stateMap.keys())}
      value={filterParams.states?.map((id) => `${id}`)}
      onChange={(_event, newValue) => {
        setFilterParams({
          ...filterParams,
          states: [...newValue]
            .sort((a, b) => {
              const stateA = stateMap.get(a);
              const stateB = stateMap.get(b);
              return (stateA?.name || "").localeCompare(stateB?.name || "");
            })
            .map((id) => parseInt(id)),
        });
      }}
      renderInput={(params) => <TextField {...params} label="State" />}
      getOptionLabel={(option) => {
        const state = stateMap.get(option);
        if (!state) {
          return "";
        }
        return state.name;
      }}
      disableCloseOnSelect
    />
  );
}
